import React from 'react';

const Logo = ({ className = "" }) => {
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      {/* Logo Image - Larger Size */}
      <img 
        src="https://customer-assets.emergentagent.com/job_rtech-builder/artifacts/tdej4mei_logo.png"
        alt="R-Technos Logo"
        className="h-16 w-auto"
        style={{ 
          objectFit: 'contain',
          imageRendering: 'crisp-edges'
        }}
      />
      
      {/* Company Name and Tagline */}
      <div className="flex flex-col justify-center leading-tight">
        <span 
          className="text-2xl font-bold text-gray-900 tracking-tight" 
          style={{ fontFamily: '-apple-system, BlinkMacSystemFont, SF Pro Display, sans-serif', letterSpacing: '-0.02em' }}
        >
          R-Technos
        </span>
        <span 
          className="text-[10px] text-gray-600 font-medium tracking-wide text-center" 
          style={{ fontFamily: '-apple-system, BlinkMacSystemFont, SF Pro Text, sans-serif' }}
        >
          IT Sales & Services
        </span>
      </div>
    </div>
  );
};

export default Logo;